import BsaConfigScreen from '@/pages/BsaConfigScreen';
const routes = [
  {
    path: '/energy-storage/basic/bsa/:bsaId/config',
    permission: '',
    element: <BsaConfigScreen />,
  },
];
export default routes;
